// extracted by mini-css-extract-plugin
export default {"heading":"BiddingStrategy_heading__Agqgm","wrapper":"BiddingStrategy_wrapper__sefM-","bidStrategyContainer":"BiddingStrategy_bidStrategyContainer__1r8MN"};